import { EditFormGroup } from "components";
import { forwardRef } from "react";

export const LoginForm = forwardRef(
  (
    {
      data = {},
      type = "state",
      inputType = "email",
      phoneCode = 64,
      onChange = () => {},
      onError = () => {},
      onChangePhoneCode = () => {},
      // define onchange parameter 'state', 'event', 'name-value'
    },
    ref
  ) => {
    return (
      <div>
        <EditFormGroup
          ref={ref}
          data={data}
          onChange={onChange}
          onError={onError}
          type={type}
          inputType={inputType}
          layout={[
            {
              name: "verifyData",
              placeholder: "E-mail or Phone",
              type: "phoneInput",
              size: "medium",
              required: true,
              phoneCode: phoneCode,
              inputType: inputType,
              startIcon: "EmailOutlined",
              onChangePhoneCode: onChangePhoneCode,
            },
            {
              name: "password",
              placeholder: "Password",
              size: "medium",
              type: "password",
              required: true,
              startIcon: "LockOutlined",
            },
          ]}
          fullWidth={true}
          direction="column"
          spacing={2}
        />
      </div>
    );
  }
);
